import { ActionIcon, CopyButton, Group, Text, Tooltip } from '@mantine/core';
import { IconCheck, IconCopy } from '@tabler/icons-react';

type Props = {
  label: string;
  value?: string | null;
  /** 値が空のときに代わりに出す語 */
  emptyLabel?: string;
  /** 手で打てない長さの値（ID など）にコピーを付ける */
  copyable?: boolean;
};

// 変えられない値は入力欄の形をさせない（押しても編集できず、無効化された欄とも読める）
export function LabeledValue({ label, value, emptyLabel = '未設定', copyable }: Props) {
  return (
    <div>
      {/* 対応する入力欄が無いので label 要素は使わない */}
      <Text size="sm" c="dimmed">
        {label}
      </Text>
      <Group gap="xs" wrap="nowrap">
        <Text c={value ? undefined : 'dimmed'} className="break-all">
          {value || emptyLabel}
        </Text>
        {copyable && value && (
          <CopyButton value={value} timeout={1500}>
            {({ copied, copy }) => (
              <Tooltip label={copied ? 'コピーしました' : 'コピー'} withArrow>
                <ActionIcon
                  variant="subtle"
                  color="gray"
                  onClick={copy}
                  aria-label={`${label}をコピー`}
                >
                  {copied ? <IconCheck size={16} /> : <IconCopy size={16} />}
                </ActionIcon>
              </Tooltip>
            )}
          </CopyButton>
        )}
      </Group>
    </div>
  );
}
